import React from "react";
import { Button, Form, Input } from "antd";
import { useMutation } from "@apollo/client";
import { STAND_TYPE_META_SET } from "graphql/mutation/stand-gql";
import { errorNotification, successNotification } from "components/request-result";
import { Localize } from "components/service";

interface IStandAdd3dModelFormProps {
  standTypeId: string;
  initialUrl?: string;
  metaFieldId?: string;
  action: () => void;
}

const StandAdd3dModelForm: React.FC<IStandAdd3dModelFormProps> = ({ standTypeId, initialUrl, metaFieldId, action }) => {
  const [form] = Form.useForm<{ url: string }>();

  const [set3dModel, { loading }] = useMutation(STAND_TYPE_META_SET, {
    update(cache, { data }) {
      const { standTypeMetaSet: { label, message } } = data;
      successNotification({ title: label, description: message });
    },
    onError(error) {
      errorNotification(error);
    },
  });

  const onFinish = (values: { url: string }) => {
    const isUpdate = !!initialUrl && !!metaFieldId;
    set3dModel({
      variables: {
        stand_type_id: standTypeId,
        input: [
          {
            id: isUpdate ? metaFieldId : undefined,
            action: isUpdate ? "update" : "create",
            meta_key: "additional_stand_type_fields_3d_model",
            meta_group: "3d_models",
            meta_value: values.url,
          },
        ],
      },
    }).then(() => {
      action();
      form.resetFields();
    });
  };

  return (
    <Form
      key="add-3d-model-form"
      className="add-3d-model-form"
      layout="vertical"
      form={form}
      initialValues={{ url: initialUrl || "" }}
      onFinish={onFinish}
    >
      <Form.Item
        name="url"
        label={<Localize>FORMS.Input_Label_3DModelUrl</Localize>}
        rules={[
          { required: true, message: <Localize>FORM_RULES.Required_3DModelUrl</Localize> },
          {
            validator: (_, value) => {
              if (!value || /^(https?:\/\/)/.test(value)) return Promise.resolve();
              return Promise.reject(<Localize>FORM_RULES.Invalid_Url</Localize>);
            },
          },
        ]}
      >
        <Input placeholder="https://example.com/3d-model" />
      </Form.Item>
      <div className="form-btn-holder">
        <Button className="light-bg" onClick={action}>
          <Localize>GLOBAL.Button_Text_Cancel</Localize>
        </Button>
        <Button className="btn-right" type="primary" htmlType="submit" loading={loading}>
          <Localize>GLOBAL.Button_Text_Confirm</Localize>
        </Button>
      </div>
    </Form>
  );
};

export default StandAdd3dModelForm;